import {pageInfo,} from './../api';
import {supplierList, plant} from '../../../../api'
import {Message} from 'element-ui';

const purchArrivalPlanLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    supplierTypeObj: [],
    plantObj: [],
    exportObj: []
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    SUPPLIER(state, data) {
      state.supplierObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async supplier({commit}, obj) {
      let resp = await supplierList(obj);
      commit('SUPPLIER', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default purchArrivalPlanLog



// WEBPACK FOOTER //
// ./src/page/bd/purchArrivalPlanLog/store/purchArrivalPlanLog.store.js